import { create } from '@thoughtspot/logger';
import _ from 'lodash';
import { ErrorTypes, getChartDataValidationError, } from '../core/chart-data-validation';
import { getChartType } from '../core/chart-model-utils';
import { isKPIChartEnhancementsEnabled } from '@thoughtspot/session-service';
import { ChartType } from '../types';
import { getLegendLabels } from '../core/chart-type-specification-service';
import { computeMetaDataInformation, processDataModel, } from '../data/chart-data-processor-service';
import { generateQueryDefinitions, transformData } from '../data/data-util';
import { getEnvOptions, initChartLibEnvOptions, isChartLibInitialized, } from '../env';
const baseChartLogger = create('base-chart-logger');
export class BaseChart {
    constructor(el, chartModel, options, chartOptions = {}) {
        this.el = el;
        this.chartModel = chartModel;
        this.chartOptions = chartOptions;
        this.options = getEnvOptions(options);
        this.eventsMap = new Map();
        this.queryDefinitions = generateQueryDefinitions(this.chartModel);
        this.setData(chartModel.data);
        if (this._error) {
            return;
        }
        this.prevRenderState = _.assign({});
        this.allSeriesIds = getLegendLabels(this.chartModel, this.dataModel).map(legendLabel => legendLabel.id);
        if (!isChartLibInitialized()) {
            initChartLibEnvOptions(options);
        }
    }
    setData(data) {
        if (data) {
            this.data = transformData(data);
            this.processData();
            this._error = this._error || this.processError();
        }
    }
    processError() {
        const dataValidationError = getChartDataValidationError(this.dataModel, this.chartModel);
        if (dataValidationError) {
            return dataValidationError;
        }
        return undefined;
    }
    processData() {
        const isKpiChart = getChartType(this.chartModel) === ChartType.Kpi;
        const shouldBypassNoDataForKpi = isKpiChart && isKPIChartEnhancementsEnabled();
        if (!this.data) {
            if (!shouldBypassNoDataForKpi) {
                this._error = ErrorTypes.NO_DATA;
            }
            return;
        }
        const emptyDataArray = this.data.filter(res => {
            return res.data.length === 0;
        });
        if (emptyDataArray.length > 0) {
            if (!shouldBypassNoDataForKpi) {
                this._error = ErrorTypes.NO_DATA;
            }
            return;
        }
        this.dataModel = processDataModel(this.chartModel, this.data, this.queryDefinitions, this.options, this.chartOptions, () => this.eventsMap);
        this.metaInfo = computeMetaDataInformation(this.chartModel, this.dataModel);
    }
}
//# sourceMappingURL=base-chart.js.map